import {combineReducers} from 'redux';
import AddressReducer from './AddressFetcher';


export default combineReducers({
   firstReducer:AddressReducer,
})